import { IAtendimentoGenericoVendas } from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import {
    IAnexoVenda,
    IClienteCompletoUAU,
    IClienteDadosUau,
    ICobrancaVenda,
    IEscritura,
    IInformacoesErp,
    IVendaInfo,
} from "../../../Interfaces/Geral/InformacoesVenda/InformacoesVendaInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarEscriturasService(codigoStatusEscritura: string) {
    return Axios.get<Array<IEscritura>>(
        `/cobranca/buscacliente/listarescrituras?codigoStatusEscritura=${codigoStatusEscritura}`
    );
}

export async function ListarCobrancasService(codigoStatusCobranca: string) {
    return Axios.get<Array<ICobrancaVenda>>(
        `/cobranca/buscacliente/listarcobrancas?codigoStatusCobranca=${codigoStatusCobranca}`
    );
}

export async function GetVendaService(ID_CHAVE_ERP: string) {
    return Axios.get<IVendaInfo>(
        `/cobranca/buscacliente/getvenda?ID_CHAVE_ERP=${ID_CHAVE_ERP}`
    );
}

export async function ListarAnexosVendaService(ID_CHAVE_ERP: string) {
    const [empresa, obra, venda] = ID_CHAVE_ERP.split("_");
    return Axios.get<Array<IAnexoVenda>>(
        `/home/historico/listaranexosvendasuau?empresa=${empresa}&obra=${obra}&venda=${venda}`
    );
}

export async function BuscarCategoriasVendaUauService(idContaProduto: number) {
    return Service(
        Axios.get<Array<IInformacoesErp>>(
            `/cobranca/contaproduto/buscarcategoriasvendauau?idContaProduto=${idContaProduto}`
        )
    );
}

export async function VerificarInadimplenciaProdutoService(idCaso: number) {
    return Service(
        Axios.get<boolean>(
            `/home/verificainadimplencia/verificainadimplenciaproduto?idCaso=${idCaso}`
        )
    );
}

export async function getInforVendasService(ID_CASO: number) {
    return Service(
        Axios.get<IAtendimentoGenericoVendas>(
            `vendas/atendimentosvendas/informacoesvendas?ID_CASO=${ID_CASO}`
        )
    );
}

export async function BuscarClienteCompletoService(ID_CHAVE_ERP: string) {
    return Axios.get<Array<IClienteDadosUau>>(
        `/cobranca/buscacliente/clientecompleto?ID_CHAVE_ERP=${ID_CHAVE_ERP}`
    );
}

export async function ListarClienteCompletoService(DS_NOME: string) {
    return Axios.get<Array<IClienteCompletoUAU>>(
        `/cobranca/buscacliente/clienteuau?DS_NOME=${DS_NOME}`
    );
}
